<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline font-weight-light blue--text">Datos Personales</span>
        </v-card-title>
        <v-card-text v-if="datos">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    label="Nombre*"
                    v-model="datos.nombre"
                    @input="forceUppercase($event, datos, 'nombre')"
                    v-validate="'required|min:3|max:50'"
                    data-vv-name="nombre"
                    id="nombre"
                    name="nombre"
                    maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    label="Primer apellido*"
                    v-model="datos.apellido1"
                    @input="forceUppercase($event, datos, 'apellido1')"
                    v-validate="'required|min:3|max:50'"
                    data-vv-name="apellido1"
                    id="apellido1"
                    name="apellido1"
                    maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    label="Segundo apellido*"
                    v-model="datos.apellido2"
                    @input="forceUppercase($event, datos, 'apellido2')"
                    v-validate="'required|min:3|max:50'"
                    data-vv-name="apellido2"
                    id="apellido2"
                    name="apellido2"
                    maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <span class="blue--text body-1">Dirección:</span>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    label="Calle*"
                    v-model="datos.direccion.calle"
                    @input="forceUppercase($event, datos.direccion, 'calle')"
                    v-validate="'required|min:3|max:50'"
                    data-vv-name="calle"
                    id="calle"
                    name="calle"
                    maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    v-model="datos.direccion.provincia"
                    :items="getProvinciasSelect"
                    :filter="customFilter"
                    item-text="text"
                    label="Provincia*"
                    @change="changeProvincia"
                    v-validate="'required'"
                    data-vv-name="provincia"
                    id="provincia"
                    name="provincia"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md8>
                  <v-autocomplete
                    v-model="datos.direccion.localidad"
                    :items="getMunicipiosSelect"
                    :filter="customFilter"
                    item-text="text"
                    label="Localidad*"
                    v-validate="'required'"
                    data-vv-name="localidad"
                    id="localidad"
                    name="localidad"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="C.P.*"
                    type="number"
                    v-model="datos.direccion.cp"
                    v-validate="'required|min:4|max:5'"
                    data-vv-name="cp"
                    id="cp"
                    name="cp"
                    maxlength="5"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <span class="blue--text body-1">Fecha de nacimiento:</span>
                </v-flex>
                <v-flex xs3 sm2>
                  <v-autocomplete
                    v-model="datos.fechaNacimientoDia"
                    :items="fechaNac.dias"
                    label="Dia*"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm2>
                  <v-autocomplete
                    v-model="datos.fechaNacimientoMes"
                    :items="fechaNac.meses"
                    label="Mes*"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 sm2>
                  <v-autocomplete
                    v-model="datos.fechaNacimientoYear"
                    :items="fechaNac.years"
                    label="Año*"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    label="NIF*"
                    v-model="datos.nif"
                    @input="forceUppercase($event, datos, 'nif')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    v-model="datos.sexo"
                    :items="[{text: 'Hombre', value: 1}, {text: 'Mujer', value: 2}]"
                    :filter="customFilter"
                    item-text="text"
                    label="Sexo"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <span class="blue--text body-1">Teléfono/s:</span>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field label="Móvil Principal*" v-model="datos.tlf1"></v-text-field>
                </v-flex>
                <v-flex xs12 sm9>
                  <v-combobox
                    v-model="datos.tlf"
                    :items="phoneItems"
                    :search-input.sync="phoneSearch"
                    hide-selected
                    hint="Escriba un número de teléfono y presione ENTER para introducirlo"
                    label="Otros teléfonos de contacto"
                    multiple
                    persistent-hint
                    deletable-chips
                    small-chips
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <span class="blue--text body-1">Discapacidad:</span>
                </v-flex>
                <v-flex xs12>
                  <!-- <v-switch
                        v-model="datos.discapacidad.isDiscapacidad"
                        :label="discapacidadLabel"
                  ></v-switch>-->
                  <v-switch v-model="datos.discapacidad.isDiscapacidad">
                    <template v-slot:label>
                      ¿Tiene alguna discapacidad reconocida?:&nbsp;&nbsp;
                      <span :class="discapacidadLabel.class">{{discapacidadLabel.text}}</span>
                    </template>
                  </v-switch>
                </v-flex>
                <template v-if="datos.discapacidad.isDiscapacidad">
                  <v-flex xs12 sm9>
                    <v-radio-group v-model="datos.discapacidad.tipo" column>
                      <v-radio label="i: cerebral, mental, intelectual" color="green" value="i"></v-radio>
                      <v-radio label="ii: Física o sensorial" color="red" value="ii"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field
                      :disabled="!!!datos.discapacidad.tipo"
                      label="Grado"
                      v-model="datos.discapacidad.grado"
                      prefix="%"
                      maxlength="2"
                      type="number"
                      min="33"
                      max="99"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch
                      v-model="datos.discapacidad.documentoDiscapacidad"
                      label="¿Tiene un documento acreditativo de su discapacidad?"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch
                      v-model="datos.discapacidad.movilidad"
                      label="¿Tiene reducida su movilidad?"
                    ></v-switch>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-form>
          <small>*Campos requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="cancelForm">Cerrar</v-btn>
          <v-btn
            :disabled="!isCumplimentado"
            color="blue darken-1"
            flat
            @click="saveDataForm"
          >Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { completaNif } from "@/plugins/functions.js";
export default {
  props: ["usuario", "formName", "isNewUser"],
  data: () => ({
    dialog: false,
    datos: null,
    phoneItems: [],
    phoneSearch: null,
    requidedItems: [
      "apellido1",
      "apellido2",
      "nombre",
      "nif",
      "tlf1",
      "fechaNacimientoDia",
      "fechaNacimientoMes",
      "fechaNacimientoYear"
    ],
    requiredItemsDireccion: ["calle", "provincia", "localidad", "cp"],
    valid: false
  }),
  mounted() {
    // this.$refs.form.resetValidation();
  },
  watch: {
    dialogUsuarioInmueble(newValue) {
      console.log("cambio por watch");
      this.dialog = newValue;
    },
    dialog(newValue) {
      if (newValue) {
        
        console.log("abierto diálogo. leer usuario...");
        this.datos = Object.assign(
          {},
          this.propietarioModel,
          JSON.parse(JSON.stringify(this.usuario))
        );
        if (this.datos.direccion.provincia) {
          this.setMunicipios(this.datos.direccion.provincia);
        }
        // this.$refs.form.resetValidation();
      } else {
        this.valid = false;
      }
      this.setPropietarioDialog({
        dialog: this.formName,
        value: newValue
      });
    }
  },
  computed: {
    ...mapGetters([
      "getProvinciasSelect",
      "getMunicipiosSelect",
      "dialogUsuarioInmueble",
      "propietarioModel",
      "fechaNac",
      "getUserUid"
    ]),
    discapacidadLabel() {
      let result = { class: "red--text", text: " - No -" }; // 'Ninguna discapacidad reconocida';
      if (this.datos && this.datos.discapacidad.isDiscapacidad) {
        result = { class: "green--text", text: " - Si -" }; // 'Padezco alguna discapacidad reconocida'
      }
      // result = `¿Tiene reconocida alguna discapacidad? ${result}`;
      return result;
    },
    isDireccionCumplimentado() {
      if (!this.datos || !this.datos.direccion) {
        return false;
      }
      const keys = Object.keys(this.datos.direccion);
      if (!keys || keys.length < 1) {
        return false;
      }
      const res1 = !!this.datos.direccion.calle && !!this.datos.direccion.cp && !!this.datos.direccion.provincia && !!this.datos.direccion.localidad;
      if (!res1) {
        return false;
      }
      const result = res1 && this.datos.direccion.calle.length > 0 && this.datos.direccion.cp.length > 0 && this.datos.direccion.provincia.length > 0;
      return result;
      /* return {
        calle: {
          bit: !!this.datos.direccion.calle,
          data: this.datos.direccion.calle
        },
        cp: {
          bit: !!this.datos.direccion.cp,
          data: this.datos.direccion.cp
        },
        provincia: {
          bit: !!this.datos.direccion.provincia,
          data: this.datos.direccion.provincia
        },
        localidad: {
          bit: !!this.datos.direccion.localidad,
          data: this.datos.direccion.localidad
        },
        res1: res1,
        result: result
      }; */
      /* if (!this.datos || !this.datos.direccion) {
        return false;
      }
      const keys = Object.keys(this.datos.direccion);
      if (!keys || keys.length < 1) {
        return false;
      }
      let result = true;
      const buscar = this.requiredItemsDireccion;
      // return buscar;
      buscar.forEach(key => {
        const element = this.datos.direccion[key];
        if (!element || element.length < 1) {
          console.log(`****** key: ${key} *****`);
          result = false;
        }
      });
      return result; */
    },
    isCumpleDiscap() {
      if (!this.datos) {
        return false;
      }
      const discap = this.datos.discapacidad.isDiscapacidad;
      let cumpleDisc = true;
      if (discap) {
        cumpleDisc = !!this.datos.discapacidad.tipo && !!this.datos.discapacidad.grado;
      }
      return cumpleDisc;
    },
    isCumplimentado() {
      if (!this.datos) {
        return false;
      }
      const result = this.valid 
        && this.isDireccionCumplimentado
        && this.datos.nombre.length > 0
        && this.datos.apellido1.length > 0
        && this.datos.apellido2.length > 0
        && this.datos.nif.length > 0
        && !!this.datos.fechaNacimientoDia
        && !!this.datos.fechaNacimientoMes
        && !!this.datos.fechaNacimientoYear
        && this.datos.tlf1.length > 0
        && this.isCumpleDiscap;
      return result;
      // return true;
      /* if (!this.datos) {
        return false;
      }
      const keys = Object.keys(this.datos);
      if (!keys || keys.length < 1) {
        return false;
      }
      let result = true;
      const buscar = this.requidedItems;
      buscar.forEach(key => {
        const element = this.datos[key];
        if (!element || element.length < 1) {
          result = false;
        }
      });
      return this.isDireccionCumplimentado; // && result */
    },
    testCumplimenta() {
      return {
        fechaNacimientoDia: !!this.datos.fechaNacimientoDia,
        fechaNacimientoMes: !!this.datos.fechaNacimientoMes,
        fechaNacimientoYear: !!this.datos.fechaNacimientoYear
      }
    }

  },
  methods: {
    ...mapActions([
      "saveDataUser",
      "setMunicipios",
      "setPropietarioDialog",
      "updateCoPropietario"
    ]),
    customFilter(item, queryText) {
      const textOne = item.text.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    },
    changeProvincia() {
      this.setMunicipios(this.datos.direccion.provincia);
      this.datos.direccion.localidad = null;
    },
    forceUppercase(e, o, prop) {
      // this.aaa = e
      if (prop === "nif" && o.nif.length === 8) {
        this.$set(o, prop, completaNif(o.nif));
        return;
      }
      //https://forum.vuejs.org/t/inputs-always-in-uppercase-using-v-model/7450/9
      e = e.toUpperCase();
      this.$set(o, prop, e);
    },
    saveDataForm() {
      // this.saveDataUser(this.datos);
      this.updateCoPropietario(this.datos);
      this.dialog = false;
    },
    cancelForm() {
      if (this.isNewUser && this.isNewUser === this.datos.id) {
        this.$emit('deleteUser', this.isNewUser);
      }
      this.dialog = false;
    }
  }
};
</script>
